export default __webpack_public_path__ + "static/media/eye-close.3517cd81.svg";